import React from 'react';
import { ShopPayButton } from '../ShopPayButton';
import { useProduct } from '../ProductProvider';
/**
 * The `SelectedVariantShopPayButton` component renders a `ShopPayButton` for the product's selected variant.
 * It must be a descendent of a `ProductProvider` component.
 */
export function SelectedVariantShopPayButton({ 
/** A string of classes to apply to the `div` that wraps the `shop-pay-button` web component. */
className, }) {
    var _a;
    const product = useProduct();
    if (product == null) {
        throw new Error('Expected a ProductProvider context, but none was found');
    }
    const id = (_a = product === null || product === void 0 ? void 0 : product.selectedVariant) === null || _a === void 0 ? void 0 : _a.id;
    return id ? React.createElement(ShopPayButton, { className: className, variantIds: [id] }) : null;
}
